import axios from "axios"
const URL = process.env.REACT_APP_MASTER_URL


export async function getTimelineMasterData() {
  console.log("inside TimelineMaster")
  const url = `${URL}/enquiry/sharepointlist/dealerData`;
  console.log("inside getDealerMasterData", url)
  let response = await axios.get(url);
  console.log("inside inside getDealerMasterData", response.data)

  return response.data;
}

export async function getTimelineData() {
  const url = `${URL}/enquiry/sharepointlist/timeline`;
  let response = await axios.get(url);
  return response.data;
}

export async function addTimelineMaster(data) {
  console.log('addtimelinedata', data);
  let url = `${URL}/enquiry/sharepointlist/addtimeline`;
  console.log("url", url);
  let response = await axios.post(url, data);
  console.log("ADD ENQUIRY URL: ", response, response.data)
  return response.data;
}

export async function getPgVariety(pg) {
  const url = `${URL}/enquiry/sharepointlist/pgVariety/${pg}`;
  let response = await axios.get(url);
  return response.data;
}

export async function getPgVarietyTitle() {
  const url = `${URL}/enquiry/sharepointlist/getpgvarietytitle`;
  let response = await axios.get(url);
  return response.data;
}

export async function getFileNames(id,linkType) {
  const url = `${URL}/enquiry/sharepointlist/${linkType}/names/${id}`
  let response = await axios.get(url);
  console.log("response of file name:: ", response.data.data)
  return response.data.data;
}

export async function downloadFile(itemId, filename,linkType) {
  const url = `${URL}/enquiry/sharepointlist/${linkType}/file`;
  const response = await axios.post(url, { itemId, filename });
  return response.data;
}

export async function getPresignedUrl(fileName, fileSize, enquiryNumber,linkType) {
  const url = `${URL}/enquiry/presignedurl/type/${linkType}/name/${encodeURIComponent(fileName)}/size/${fileSize}/enquiry/${enquiryNumber}`;
  const response = await axios.get(url);
  return response.data;
}

export async function uploadFileToS3(presignedUrl, file) {
  console.log("inside upload s3 function")
  const response = await axios.put(presignedUrl, file, {
    headers: {
      'Content-Type': file.type
    }
  });
  console.log("response in s3 upload", response)
  return response;
}

export async function deleteFile(fileKey,linkType) {
  const url = `${URL}/enquiry/sharepointlist/${linkType}/deletefile`;
  const response = await axios.post(url, { fileKey });
  return response.data;
}